export const AllIconGroups = {
    REGULAR: 'regular',
    SOLID: 'solid',
    LIGHT: 'light',
    THIN: 'thin',
    DUOTONE: 'duotone',
    BRANDS: 'brands',
};

export const AllIconAnimations = {
    BEAT: 'beat',
    FADE: 'fade',
    FLASH: 'flash',
    FLIP: 'flip',
    PULSE: 'pulse',
    SPIN: 'spin',
    SPIN_PULSE: 'spin-pulse',
};

export const ICON_GROUPS = [
    AllIconGroups.REGULAR,
    AllIconGroups.SOLID,
    AllIconGroups.LIGHT,
    AllIconGroups.THIN,
    AllIconGroups.DUOTONE,
    AllIconGroups.BRANDS,
];

export const ICON_ANIMATIONS = [
    AllIconAnimations.BEAT,
    AllIconAnimations.FADE,
    AllIconAnimations.FLASH,
    AllIconAnimations.FLIP,
    AllIconAnimations.PULSE,
    AllIconAnimations.SPIN,
    AllIconAnimations.SPIN_PULSE,
];